import React, { useEffect } from "react";
import * as echarts from "echarts";

export const ChartMargen = ( {data} ) => {
  useEffect(() => {
    const dom = document.getElementById("chart-container-margen");
    const myChart = echarts.init(dom, null, {
      renderer: "canvas",
      useDirtyRect: false,
    });

    const utilidadbruta = data?.estadoresultadoreal?.utilidadbruta;
    const ventasnetas = data?.estadoresultadoreal?.ventaneta;

    const calcularporcentaje = (param, ventasNetas) => {
      if (!ventasNetas) return 0;
      return ((param / ventasNetas) * 100).toFixed(2);
    };

    const margenreal = calcularporcentaje(utilidadbruta, ventasnetas);
    const margenproyectado = data?.estadoresultadoproyectado?.margenoperacionproyectado;

    const proyeccion = margenproyectado; 
    const value = margenreal; 

    
    const porcentajeprogreso = (value / proyeccion) * 100;

    
    const getColor = (porcentaje) => {
      if (porcentaje <= 50) return "#f44336"; 
      if (porcentaje <= 80) return "#ffc107"; 
      return "#035917"; 
    };

    const option = {
      title: {
        text: `Proyección: ${proyeccion}%`,
        left: '62%', 
        top: '57%', 
        textStyle: {
          fontSize: 11,
        },
      },
      series: [
        {
          type: 'gauge',
          center: ['50%', '55%'], 
          radius: '90%', 
          startAngle: 180, 
          endAngle: 0,
          max: proyeccion, 
          progress: {
            show: true, 
            width: 40,
            itemStyle: {
              color: getColor(porcentajeprogreso), 
            },
          },
          axisLine: {
            lineStyle: {
              width: 40, 
              color: [
                [1, '#dae6be'], 
              ],
            },
          },
          pointer: {
            itemStyle: {
              color: getColor(porcentajeprogreso), 
            },
          },
          axisTick: {
            show: false,
            margin: 10,
          },
          splitLine: {
            show: false, 
          },
          axisLabel: {
            show: false, 
          },
          detail: {
            formatter: '{value}%', 
            offsetCenter: [0, '50%'], 
          },
          data: [
            {
              value: margenreal, 
            },
          ],
        },
      ],
    };

    myChart.setOption(option);

    window.addEventListener("resize", () => {
      myChart.resize();
    });

    return () => {
      window.removeEventListener("resize", () => {
        myChart.resize();
      });
      myChart.dispose();
    };
  }, [data]);

  return (
    <div
      id="chart-container-margen"
      style={{
        width: "399px",
        height: "290px",
      }}
    ></div>
  );
};
